"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_document_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const sign_document_1 = require("../../../../../api/calls/document/sign_document");
const sign_document_thunk = (0, toolkit_1.createAsyncThunk)("document/sign_document", (request, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const response = yield (0, sign_document_1.sign_document)(request);
        if (response === null || response === void 0 ? void 0 : response.success) {
            return response.data;
        }
        else {
            return rejectWithValue((_a = response === null || response === void 0 ? void 0 : response.message) !== null && _a !== void 0 ? _a : "Failed to sign document");
        }
    }
    catch (error) {
        return rejectWithValue((_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : "Failed to sign document");
    }
}));
exports.sign_document_thunk = sign_document_thunk;
